import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import SubscriptionCenterSetPreferencesTypeController from 'cio/pods/workspace-settings/subscription-center/topics/set-preferences/type/controller';
import { SetPreferencesType } from 'cio/utils/subscription-center';
import SubscriptionCenterService from 'cio/services/subscription-center';
import { inject as service } from '@ember/service';

export default class SubscriptionCenterSetPreferencesTypeRoute extends Route {
  @service subscriptionCenter!: SubscriptionCenterService;

  async beforeModel(transition: Transition) {
    super.beforeModel(transition);

    this.subscriptionCenter.initializeTask.perform(true);
    this.subscriptionCenter.fetchPendingMessageLists.perform({});
    this.subscriptionCenter.fetchCompletedMessageLists.perform({});
    this.subscriptionCenter.fetchAllMessageLists.perform({});
  }

  resetController(
    controller: SubscriptionCenterSetPreferencesTypeController,
    isExiting: boolean,
    transition: Transition,
  ) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.setProperties({
        type: SetPreferencesType.Pending,
        page: 1,
        searchString: null,
        searchTagIds: [],
        searchTopicId: null,
        searchType: null,
        sendToUnsubscribed: null,
        searchAudience: null,
      });
    }
  }
}
